module.exports = __webpack_public_path__ + "static/media/twitter.dd90206d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter.svg
// module id = 20
// module chunks = 0